
export const TalentPage = () => {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Talent Booking</h1>
      <div className="text-muted-foreground">
        Post gig slots and connect with performers (Coming Soon).
      </div>
    </div>
  );
};
